export default __webpack_public_path__ + "static/lifeprint-banner-be5761bb304f53fcf1c2bb9c85e7b1f2.webp";